{
  "loading": "Cargando",
  "howToPlay": "Como jugar:",
  "howToPlayControls": "- Flechas: Movimiento\n- Tecla A: Acción",
  "pressToStart": "Pulsa la tecla A o toca la pantalla para empezar",
  "wardrobe1": "Mi ropa está aquí, a ver si encuentro mi camiseta roja ...  ",
  "wardrobe2": "¡Aquí está la camiseta! Cojo también el resto de ropa ... ¡Ya lo tengo todo!",
  "wardrobe3": "¡Ya he cogido la ropa!",
  "wardrobeNoClothes": "Ropa y más ropa ... ¡Pero aquí no hay nada que sea mío!",
  "bathroom1": "¡Hora de ducharse!",
  "bathroomFail1": "Antes de ducharme, necesito coger la ropa que me pondré. La ropa está uno de los armarios de la habitación.",
  "likeNew": "Ya estoy preparado. ¡Me siento mucho mejor!",
  "wakeUpFreeman": "Despierte, señor Freeman..., despierte y mire a su alrededor...",
  "wakeUpAlbert": "... Quiero decir, Albert! ¡Despierta o llegarás tarde al trabajo!",
  "ellipsis": "...",
  "ellipsisX2": "......",
  "rightNow": "Sí... Ahora mismo me levanto.",
  "walkCobi": "Voy a pasear a Cobi, y cuando vuelva yo también me iré al trabajo. ¡Hasta luego!",
  "bark": "Guau!",
  "prepare": "Bueno, me tengo que preparar: Primero toca ducha y después coger el portátil antes de salir hacia el trabajo.",
  "prepare2": "Usa Las flechas para controlar el personaje y la letra A para interactuar con objetos. Con La letra M se puede abrir el menú, que también se controla con las flechas y A.",
  "prepare3": "Con la letra S se puede activar / desactivar el sonido. Por último, con la letra F se puede activar / desactivar el modo de pantalla completa.",
  "prepare4": "¡Es tu oportunidad, investiga por los mapas y por el menú del juego para saber más de mí!",
  "shelves1": "Aquí hay libros de todo tipo. Lo que más me gusta leer es literatura fantástica y de ciencia ficción, pero puedo leer otros tipos de libros sin problemas.",
  "shelves2": "Videojuegos y más videojuegos. Son uno de mis hobbies favoritos. Mi primera consola fue el Atari 2600, y desde entonces he continuado jugando tanto a juegos de consola como de ordenador.",
  "shelves3": "Aquí tengo algunos libros sobre tecnología y metodología. Me gusta aprender cosas nuevas, ya sea leyendo o desarrollando proyectos, como este juego al que juegas ahora mismo :)",
  "shelves4": "Aquí tengo algunas figuritas. No soy ningún coleccionista, pero sí me gusta de vez en cuando coger figuritas de temas que me gustan.",
  "noeDesktop": "El escritorio de Noe. No tengo poder aquí.",
  "albertDesktop": "Mi escritorio. ¡Aquí paso muchas horas! Mi portátil del trabajo está aquí, lo cojo, que lo necesito para poder trabajar en la oficina.",
  "albertDesktopFail": "Mi escritorio. ¡Aquí paso muchas horas! Mi portátil del trabajo está aquí, pero antes de poder cogerlo, me tengo que duchar.",
  "albertDesktop2": "Mi escritorio. ¡Aquí paso muchas horas!",
  "tv": "¡La TV! Aquí es donde vemos series y películas. Y por supuesto, también juego a videojuegos.",
  "couch": "¡Qué bien se está en el sofá! ¡Pero ahora no tengo tiempo de sentarme!",
  "coffeeMachine1": "¿Qué haría sin la cafetera? Ya que estoy aquí, tomaré un poco de café ...",
  "coffeeMachine2": "¡Qué bueno està! Ahora estoy al máximo!",
  "coffeeMachine3": "Haré otra taza de café para llevármela, nunca se sabe cuando se puede necesitar.",
  "coffeeMachine4": "Mejor no abusar del café, je, je, je.",
  "microwave": "¡El microondas, no podría vivir sin él!",
  "fridge": "El frigorífico está casi vacío ... ¡Tenemos que hacer la compra!",
  "door": "¡Hora de ir al trabajo!",
  "doorFail": "Aún no estoy preparado para salir...",
  "albert": "Albert",
  "noe": "Noe",
  "cobi": "Cobi",
  "officeIntro": "Más tarde en la oficina...",
  "goToDesk": "Antes de empezar a trabajar puedo hablar con los compañeros y mirar que hay por la oficina. Para empezar a trabajar, tengo que ir a mi escritorio, que está vacío ahora mismo.",
  "mf": "Miquel",
  "boss": "Raúl",
  "rs": "Raquel",
  "cc": "Carlos",
  "sn": "Sid",
  "se": "Silvia",
  "rm": "Rafa",
  "ef": "Edgar",
  "ej": "Enric",
  "fs": "Fonsi",
  "wg": "Wilder",
  "ja": "Jack",
  "yf": "Yaiza",
  "mf1": "Albert, Booooooon diiiia! Estoy echando una partida al tenis. ¿Quieres jugar? A ver quién gana!",
  "mf2": "Si quieres jugar, acércate al arcade y pulsa el botón de acción.",
  "mf3": "Después de esta emocionante partida, ¡Toca ponerse a currar!",
  "mf4": "Ahora comprobaré que el rendimiento de la nueva funcionalidad que estamos desarrollando sea correcto.",
  "arcade1": "¡Vamos a jugar! Que gane el mejor ...",
  "arcade2": "¡Ya he jugado bastante por hoy!",
  "pairProgrammingAdded": "Después de la partida, te sientes super motivado para trabajar en equipo. Como resultado, podrás hacer pair programming durante el trabajo.",
  "mfWon": "¡He ganado! Mi entrenamiento ha dado resultados. Mañana jugamos de nuevo, ahora toca trabajar.",
  "mfLost": "¡He perdido! La próxima partida la ganaré yo, ya lo verás! Mañana jugamos de nuevo, ahora toca de trabajar.",
  "rr1": "Buenos días. Estoy revisando unos libros para una formación que estoy preparando. ¡Espero que os guste!",
  "cc1": "Hola! Estoy monitoreando cómo se comportan nuestros servidores tras la última subida a producción.",
  "cc2": "¡Es importante ver que todo sigue funcionando bien!",
  "rs1": "¡Buenos días! Hoy he empezado una nueva tarea, y antes de continuar quiero reorganizar un poco el código.",
  "rs2": "¡Se debe mantener el código limpio y pulido!",
  "sn1": "Buenos días, ¿cómo estás? Me has cogido priorizando las tareas que entrarán en los próximos sprints.",
  "sn2": "¡Ya verás que interesantes!",
  "se1": "Hola, buenos días. Estoy investigando unos bugs que tenemos al sistema. Es vital ofrecer un servicio fiable!",
  "rm1": "¡Hola, chaval! Estoy mejorando el tiempo de los tests automatizados. El feedback de los tests debe ser rápido!",
  "ef1": "¡Ei! Me han pasado el nuevo diseño de la página del perfil del usuario, y estoy mirando como adaptarlo a HTML.",
  "ef2": "¡La estructura de la página es crítica!",
  "ej1": "¿Que pasa noi? Estoy mejorando el sistema de logs para tener más información si el usuario tiene",
  "ej2": "algún problema. ¡Debemos saber que pasa en nuestra aplicación!",
  "fs1": "¡Iep! Ahora mismo estoy desarrollando tests unitarios. Es imprescindible tener nuestra aplicación bien testeada!",
  "fs2": "Te doy un donut de mi alijo secreto, ¡Pero no se lo digas a nadie!",
  "wg1": "Hola, ¿Qué tal? Estoy validando que las tareas que se han desarrollado funcionan bien.",
  "wg2": "¡La calidad del software debe estar asegurada!",
  "ja1": "¡Buenos días, Albert! Estoy contestando dudas de los usuarios. Una buena atención al cliente es muy necesaria!",
  "yf1": "¡Hola, Albert! Si necesitáis ayuda con cualquier tema del trabajo, aquí estoy.",
  "officeBathroom1": "¡Ahora mismo no tengo que ir al baño!",
  "officeStuff1": "Aquí hay material de oficina, nada interesante.",
  "tv1": "Esta TV la usamos para hacer presentaciones de diferentes tipos, como por ejemplo presentaciones de los nuevos proyectos.",
  "library1": "Hay muchos libros dedicados al desarrollo de software por si necesitamos hacer ninguna consulta.",
  "library2": "Cogeré el libro de Functional-Light-JavaScript, quiero repasar unos conceptos que me ayudarán a resolver la tarea que estoy haciendo.",
  "library3": "¡Ya tengo el libro!",
  "officeMicrowave1": "¡Obviamente, aquí es donde calentamos la comida!",
  "officeCoffeeMachine1": "Me haré un café para tomar mientras trabajo. ¡Energía!",
  "officeCoffeeMachine2": "De momento ya tengo bastante café.",
  "officeFridge1": "Dentro de esta nevera hay de todo, no como en mi casa. ¡Muchas cosas deliciosas!",
  "officeFridge2": "¡Venga va! Cogeré un donut, que siempre apetecen.",
  "lockers1": "Dentro de este armario podemos dejar nuestras pertenencias.",
  "diningTable1": "La mesa para el almuerzo. Aquí es donde nos reunimos cada día y pasamos un buen rato charlando entre nosotros mientras comemos.",
  "meetingRoom1": "En esta sala se hacen todo tipo de reuniones, como las planificaciones y retrospectivas del sprint.",
  "myDesk1": "Este es mi escritorio. Quizás puedo dar un paseo antes de trabajar. Si quieres que empiece a trabajar, vuelve a examinar el escritorio.",
  "myDesk2": "¡Ahora sí! Hora de abrir el portátil y empezar.",
  "clothes": "Ropa",
  "coffee_cup": "Café",
  "coffeeDescription": "(+25 HP)",
  "flj_book": "Libro F-L JS",
  "fljBookDescription": "(+1 Skill)",
  "notebook": "Portátil",
  "donut": "Dònut",
  "donutDescription": "(+50 HP)",
  "about": "Info",
  "skills": "Skills",
  "items": "Items",
  "experience": "Experiencia →",
  "projects": "Proyectos →",
  "name": "Nombre:",
  "age": "Edad:",
  "quantity": "Cantidad:",
  "aboutMe": "Nacido en Barcelona. Acabé Ingeniería Informática en 2010, y desde entonces he trabajado como desarrollador de software. Actualmente trabajo con PHP y JavaScript.",
  "webPerf": "Perf. Web",
  "mailtrackTitle": "Fullstack Engineer at Mailtrack",
  "mailtrackDates": "Julio 2018 - Actualidad",
  "mailtrackDescription": "El principal producto de Mailtrack es una extensión de Google Chrome que permite hacer seguimiento de emails en Gmail. Por un lado trabajo en los servicios de backend, desarrollados con PHP y Node.js. Por otra parte trabajo en la extensión, desarrollada con TypeScript, CSS y HTML. También hago algunas tareas de sistemas, como configurar Docker o servicios en AWS.",
  "atrapaloLeadTitle": "Lead Frontend Developer at Atrápalo",
  "atrapaloLeadDates": "Julio 2017 - Junio 2018",
  "atrapaloLeadDescription": "Tech Lead en el equipo de Frontend de la compañía. Mis funciones eran por una parte gestionar el equipo y por otra guiar y desarrollar la arquitectura frontend de la web.",
  "atrapaloBackendTitle": "Software Developer at Atrápalo",
  "atrapaloBackendDates": "Enero 2014 - Julio 2017",
  "atrapaloBackendDescription": "Desarrollador PHP en un complejo sistema con múltiples tecnologias: RabbitMQ, Elastic, MySQL y Redis entre otras.",
  "lcfibTitle": "Becario - Developer at LCFIB",
  "lcfibDates": "Septiembre 2008 - Julio 2010",
  "lcfibDescription": "Trabajé con diferentes tecnologías. Por un lado, desarrollé con J2EE diferentes proyectos. También trabajé con Oracle Forms y Oracle Reports. Por último, trabajé con PHP y MySQL en el portal de vídeos de la FIB.",
  "carverTitle": "J2EE Developer at Carver Advanced Systems",
  "carverDates": "Septiembre 2010 - Enero 2014",
  "carverDescription": "Desarrollador J2EE y Oracle SQL haciendo una aplicación de seguros. La aplicación gestionaba y tarifas seguros de diferentes ámbitos.",
  "nsbTitle": "NoSoloBits Site",
  "nsbDescription": "NoSoloBits es una página web dedicada a juegos retro. La parte backend está hecha con PHP y MySQL. La parte frontend está hecha con HTML, JS y SASS, compilado con Webpack.",
  "easytimerTitle": "Easytimer.js",
  "easytimerDescription": "Easytimer.js es una pequeña utilidad hecha con JS que permite gestionar de forma fácil un cronómetro y una cuenta atrás.",
  "gameTitle": "Aquest Videojoc!",
  "gameDescription": "El videojuego al que estás jugando ahora mismo. Me he salido de mi zona de confort para hacerlo, ya que no soy diseñador de videojuegos. El resultado ha sido un juego sencillo y corto, pero creo que igualmente es una buena carta de presentación. Le he puesto mucha ilusión, espero que te guste!",
  "code": "Codi.",
  "codePageDescription": "Escribe código para atacar al bug.",
  "enemyDamaged": "Tu código ha hecho {{damage}} puntos de daño al bug.",
  "playerDamaged": "El bug te ha hecho {{damage}} puntos de daño.",
  "coffeeEffect": "Te tomas el café y te sientes mucho más enérgico. Te ha hecho recuperar {{ hp }} puntos de vida.",
  "donutEffect": "¡Te comes el donut con mucha hambre! Te ha hecho recuperar {{ hp }} puntos de vida.",
  "bookEffect": "Lees un capítulo que te deja más claro cómo aplicar Programación Funcional. Ahora tienes un nuevo skill disponible.",
  "debug": "Debug",
  "debugDescription": "(Ataq ↑)",
  "pairProgramming": "Pair Programming",
  "pairProgrammingDescription": "(Def ↑)",
  "functionalProgramming": "Functional Prog.",
  "functionalProgrammingDescription": "(S. Ataq)",
  "unitTesting": "Unit Testing",
  "unitTestingDescription": "(Turno Extra)",
  "battleTimeToWork": "¡Hora de trabajar! Debemos terminar una tarea muy importante que tenemos que entregar mañana.",
  "battleTimeToWork2": "Parece que todo está perfecto ...",
  "battleSomethingIsWrong": "¡Oh no! ¡Algo no va bien!",
  "battleBugFound": "¡Hemos encontrado un bug! ¡Tenemos que acabar con él antes de que sea demasiado tarde!",
  "battleTutorial": "Para acabar con el bug puedo hacer 3 cosas en el menú: Escribir código, usar una habilidad o utilizar objetos.",
  "attackPowerUpDescription": "Hacer debugging te ayuda a identificar puntos débiles del bug, aumentando tus 2 próximos ataques.",
  "defensePowerUpDescription": "Hacer pair programming os hace mucho más eficaces, aumentando la defensa durante 2 turnos.",
  "extraTurnPowerUpDescription": "Hacer refactoring y unit testing os hace detectar casos no controlados, ganando 2 turnos extra.",
  "fired": "Estás despedido",
  "refresh": "¡Refresca la página si quieres jugar de nuevo!",
  "tip": "Consejo: Busca objetos para usar en la batalla",
  "endingStory": "Tras derrotar al peligroso bug, te das cuenta que estás hecho para cazar a todas estas bestias que hacen peligrar el software del mundo entero. Sin dudar, te pones manos a la obra luchando con todas tus fuerzas, llegando incluso al mismo infierno, donde se originan estos seres malignos. La leyenda del Bug Slayer ha comenzado ...",
  "thankYou": "¡Gracias por jugar!"
}
